import './wydr';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import './i18n';
import 'react-phone-input-2/lib/style.css';

ReactDOM.render(
    <React.Suspense fallback={<div className="app-loading">Loading...</div>}>
        <Root/>
    </React.Suspense>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
